import moment from "moment";

const LastBox = () => {
    return (
        <div className="lastBox">
            <p>© {moment().format('Y')}  All rights reserved.</p>
            <ul>
                <li><a href="javascript:void(0)">Term & Condition</a></li>
                <li><a href="javascript:void(0)">Privacy & Policy</a></li>
            </ul>
        </div>
    )
}
export default LastBox;
